<template>
  <div v-if="hasAvailableUsers">
    <h3 class="text-uppercase mb-100">Invite User</h3>

    <form-field-input
      label="Email Address"
      type="email"
      v-model="form.email_address"
      :validation-errors="validationErrors.email_address"
    ></form-field-input>

    <form-field-select
      label="Is Owner"
      v-model="form.is_owner"
      :validation-errors="validationErrors.is_owner"
    >
      <option :value="true">Yes</option>
      <option :value="false">No</option>
    </form-field-select>

    <template v-if="form.is_owner">
      <p class="mt-100 mb-50">Roles</p>
      <p class="is-italic">Owners have all roles</p>
    </template>

    <template v-else>
      <p class="mt-100 mb-50">Roles</p>
      <form-field-checkbox
        label="Lead Manager"
        v-model="roles.is_lead_manager"
        require-prefix
      />

      <form-field-checkbox
        label="Acquisitions Manager"
        v-model="roles.is_acquisitions_manager"
        require-prefix
      />

      <form-field-checkbox
        label="Dispositions Manager"
        v-model="roles.is_dispositions_manager"
        require-prefix
      />

      <form-field-checkbox
        label="Rehab Manager"
        v-model="roles.is_rehab_manager"
        require-prefix
      />

      <form-field-checkbox
        label="Transaction Coordinator"
        v-model="roles.is_transaction_coordinator"
        require-prefix
      />
    </template>

    <template v-if="form.is_owner">
      <p class="mt-100 mb-50">Permissions</p>
      <p class="is-italic">Owners have all permissions</p>
    </template>

    <template v-else>
      <p class="mt-100 mb-50">Permissions</p>
      <form-field-checkbox
        label="Can Access All Leads"
        v-model="permissions.can_access_all_leads"
        require-prefix
      ></form-field-checkbox>

      <form-field-checkbox
        label="Can Delete Leads"
        v-model="permissions.can_delete_leads"
        require-prefix
      ></form-field-checkbox>

      <form-field-checkbox
        label="Can Export Leads"
        v-model="permissions.can_export_leads"
        require-prefix
      ></form-field-checkbox>

      <form-field-checkbox
        label="Can Access All Tasks"
        v-model="permissions.can_access_all_task"
        require-prefix
      ></form-field-checkbox>

      <form-field-checkbox
        label="Can Access All Appointments"
        v-model="permissions.can_access_all_appointments"
        require-prefix
      ></form-field-checkbox>

      <form-field-checkbox
        label="Can Access Comm Logs Page"
        v-model="permissions.can_access_comm_log_page"
        require-prefix
      ></form-field-checkbox>

      <form-field-checkbox
        label="Can Export Contacts"
        v-model="permissions.can_export_contacts"
        require-prefix
      ></form-field-checkbox>

      <form-field-checkbox
        label="Can Access Settings"
        v-model="permissions.can_access_settings"
        require-prefix
      ></form-field-checkbox>

      <form-field-checkbox
        label="Can Access Financial Stats"
        v-model="permissions.can_access_financial_stats"
        require-prefix
      ></form-field-checkbox>

      <form-field-checkbox
        label="Can Edit Financial Information"
        v-model="permissions.can_edit_financials"
        require-prefix
      ></form-field-checkbox>

      <form-field-checkbox
        label="Can Access Billing Information"
        v-model="permissions.can_manage_account"
        require-prefix
      ></form-field-checkbox>

      <form-field-checkbox
        label="Can Access User Permissions"
        v-model="permissions.can_manage_users"
        require-prefix
      ></form-field-checkbox>
    </template>
  </div>
  <div v-else class="upgrade_message">
    <h4 class="upgrade_message--heading">Upgrade Required</h4>
    <p class="upgrade_message--message">You've reached you limit on users.</p>
    <p class="upgrade_message--message">Please <a @click="openBillingPortal">upgrade</a> your subscription in order to
      invite more users</p>
  </div>
</template>

<script>
import {FormMixin} from "./forms.mixin";

export default {
  name: "UserInviteForm",
  props: ['formData'],
  mixins: [FormMixin],
  data() {
    return {
      validationErrors: {},
      defaultForm: {
        email_address: '',
        is_owner: false,
        markets: [this.$store.getters.market]
      },
      permissions: {
        can_access_all_leads: true,
        can_delete_leads: true,
        can_export_leads: true,
        can_access_all_task: true,
        can_access_all_appointments: true,
        can_access_settings: false,
        can_access_financial_stats: false,
        can_edit_financials: false,
        can_manage_account: false,
        can_manage_users: false,
        can_access_comm_log_page: true,
        can_export_contacts: false,
      },
      roles: {
        is_lead_manager: false,
        is_acquisitions_manager: false,
        is_dispositions_manager: false,
        is_rehab_manager: false,
        is_transaction_coordinator: false,
      },
      form: {},
    }
  },
  created() {
    this.form = (this.formData) ? this.$utils.clone(this.formData) : this.$utils.clone(this.defaultForm);
  },
  computed: {
    account() {
      return this.$store.getters.account;
    },
    userCount() {
      return this.$store.getters.activeUsers.length;
    },
    userLimit() {
      return this.account.user_limit;
    },
    hasAvailableUsers() {
      return this.userCount < this.userLimit;
    },
    hasInviteFeature() {
      return this.account.has_invite_users_feature;
    }
  },
  methods: {
    reset() {
      this.form = this.$utils.clone(this.defaultForm);
    },
    create() {
      this.form.permissions = JSON.stringify(this.permissions)
      this.form.roles = JSON.stringify(this.roles)

      return this.$api.userInvites.create(this.form)
        .then((res) => {
          this.reset()
          this.$buefy.toast.open({
            message: "Invite is on it's way",
            type: 'is-success'
          })

          return res;
        });
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/variables/variables";

.upgrade_message {
  padding: 1rem 0;
  font-style: italic;

  &--heading {
    margin-bottom: 1rem;
    font-size: 1.125rem;
    font-weight: bold;
  }

  &--message {
    margin-bottom: 8px;
    line-height: 1.4;
  }
}
</style>
